export default "__VITE_ASSET__DfjFnQ9O__"